import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Button,
  Form,
  Input,
  message,
  Modal,
  Table,
  Typography,
  Select,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import UserServices from "../../services/UserServices";
import { translate } from "../../locale";
import SimpleReactValidator from "simple-react-validator";
import { TableHelper } from "../../helpers/TableHelper";

const { Title } = Typography;

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const SendPill = ({ patient, visible, onComplete, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [values, setValues] = useState({
    subscription_id: "",
  });
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [modalDetails, setModalDetails] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [pills, setpills] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [, forceUpdate] = useState();

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
        title: "El asunto es requerido",
        message: "El mensaje es requerido",
      },
    })
  );

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <Button
            type="link"
            className="p-0 text-sm h-auto btn-link-underline"
            onClick={() => handleSend(record)}
          >
            {translate("Enviar")}
          </Button>
          <Button
            type="link"
            className="p-0 text-sm h-auto btn-link-underline"
            onClick={() => handleShowDetails(record)}
          >
            {translate("Ver")}
          </Button>
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Título"),
      dataIndex: "name",
      key: "name",
    },
  ];

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true) {
        getSubscriptions();
        getPills();
      }
    }
  }, [visible]);

  useEffect(() => {
    let data = {
      page_size: tableParams.pagination.pageSize,
      page_num: tableParams.pagination.current,
    };
    const sorter = TableHelper.sorter(tableParams);
    if (sorter !== null) {
      data = { ...data, order_by: sorter };
    }
    getPills(data);
  }, [JSON.stringify(tableParams)]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const getPills = async (data) => {
    setLoading(true);
    try {
      let response = await UserServices.getPill(data);
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.pills);
        setFilteredData(response.data.pills);
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getSubscriptions = async () => {
    try {
      setLoading(true);
      const response = await UserServices.getSubscription(patient);
      if (response.status >= 200 && response.status < 300) {
        setSubscriptions(
          response.data.subscriptions.map((i) => ({
            value: i.id,
            label: i.name,
          }))
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleSend = (data) => {
    console.log("data", data);
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError("Seleccione una suscripción.");
      return;
    }
    onSend(data);
  };

  const onSend = async (_data) => {
    setLoading(true);
    try {
      const data = {
        patient: patient,
        subscription_id: values.subscription_id,
        pill_id: _data.id,
      };
      const res = await UserServices.sendPill(data);
      if (res.data.message === "ok") {
        resetForm();
        message.success(
          translate("La {0} se envió exitosamente.", translate("píldora"))
        );
        if (onComplete) {
          onComplete();
        }
      } else {
        setError("No se pudo enviar el email");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      message.error(
        translate("La {0} no pudo ser enviada.", translate("píldora"))
      );
      setLoading(false);
    }
  };

  const resetForm = () => {
    setValues({
      text: "",
    });
  };

  const handleSearch = (text) => {
    setFilteredData(
      data.filter((i) => i.name.toLowerCase().indexOf(text.toLowerCase()) > -1)
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleCancel = () => {
    setActive(false);
    resetForm();
    if (onCancel) {
      onCancel();
    }
  };

  const handleShowDetails = (data) => {
    setModalDetails(true);
    setSelectedData(data);
  };

  const handleHideDetails = () => {
    setModalDetails(false);
  };

  return (
    <>
      <Modal
        open={active}
        title={translate("Enviar píldora")}
        onOk={null}
        onCancel={handleCancel}
        footer={false}
      >
        {error && (
          <Alert
            message={error}
            type="error"
            className="mb-6"
            closable
            onClose={() => setError("")}
          />
        )}
        <Form autoComplete="off" className="w-full">
          <Form.Item>
            <Input.Search
              placeholder={translate("Título")}
              allowClear
              enterButton={translate("Buscar")}
              size="large"
              onSearch={handleSearch}
              onChange={handleChange}
              value={values.text}
              name="text"
            />
          </Form.Item>
          <Form.Item>
            <Select
              name="subscription_id"
              onChange={(value) => {
                setValues((v) => ({ ...v, subscription_id: value }));
              }}
              value={values.subscription_id}
            >
              <Select.Option value="">Seleccione suscripción</Select.Option>
              {subscriptions.map((item, key) => (
                <Select.Option key={key} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
            {simpleValidator.current.message(
              "subscription_id",
              values.subscription_id,
              "required"
            )}
          </Form.Item>
        </Form>
        <Title level={5}>{translate("Resultado")}</Title>
        <Table
          rowKey={(i) => {
            return i.id.toString();
          }}
          dataSource={filteredData}
          columns={columns}
          pagination={{ ...tableParams.pagination, total: total }}
          onChange={handleTableChange}
          loading={
            loading
              ? { indicator: antIcon, className: "text-custom_blue" }
              : false
          }
        />
      </Modal>
      <Modal
        open={modalDetails}
        title={translate("Píldora")}
        onCancel={handleHideDetails}
        footer={[
          <Button key="ok" type="primary" onClick={handleHideDetails}>
            {translate("Aceptar")}
          </Button>,
        ]}
      >
        {selectedData !== null && (
          <p>
            <strong>{translate("Título")}: </strong> {selectedData.title}
            <br />
            <strong>{translate("Descripción")}: </strong>{" "}
            {selectedData.description}
            <br />
          </p>
        )}
      </Modal>
    </>
  );
};

export default SendPill;
